import { Component, inject } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import {
  ServiceNotificationIcon,
  ServiceNotificationItem
} from '@brightside-web/desktop/feature/service-notifications';
import { ServiceNotificationsService } from '../service-notifications.service';
import { AlertActionComponent } from '../cards/alert-action/alert-action.component';
import { InfoComponent } from '../cards/info/info.component';
import { InfoActionComponent } from '../cards/info-action/info-action.component';
import { AsyncPipe, NgForOf, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { UrgentNotificationCardComponent } from '../cards/urgent-notification-card/urgent-notification-card.component';

@Component({
    selector: 'brightside-web-service-notifications',
    imports: [
        NgIf,
        NgForOf,
        NgSwitch,
        NgSwitchCase,
        AlertActionComponent,
        InfoComponent,
        InfoActionComponent,
        NgSwitch,
        AsyncPipe,
        BrightsideUiModule,
        TranslateModule,
        LottieComponent,
        SharedDesktopModule,
        UrgentNotificationCardComponent
    ],
    templateUrl: './service-notifications.component.html',
    styleUrl: './service-notifications.component.scss'
})
export class ServiceNotificationsComponent {
  groupedNotifications$!: Observable<{
    urgent: ServiceNotificationItem[];
    alerts: ServiceNotificationItem[];
    others: ServiceNotificationItem[];
  }>;

  noNotificationsAnimation: AnimationOptions = {
    path: './assets/animation/sun.json',
    loop: true,
    autoplay: true,
  };

  private _latestGroupedNotifications: { alerts: ServiceNotificationItem[]; others: ServiceNotificationItem[] } = {
    alerts: [],
    others: []
  };
  private _serviceNotifications = inject(ServiceNotificationsService);
  private _sub = new Subscription();

  constructor() {}

  ngOnInit(): void {
    this.groupedNotifications$ = this._serviceNotifications.getGroupedNotifications$();
    this._sub.add(
      this.groupedNotifications$.subscribe((grouped) => {
        this._latestGroupedNotifications = grouped;
      })
    );
  }

  ngOnDestroy(): void {
    const allDisplayedNotifications = [
      ...this._latestGroupedNotifications.alerts,
      ...this._latestGroupedNotifications.others
    ];

    this._serviceNotifications.markAsReadByItems(allDisplayedNotifications);
    this._sub.unsubscribe();
  }

}
